/**
 * apps/dashboard/src/api/transforms/workspaceHome.ts
 *
 * Pure transform: converts raw composite result into a typed view-model.
 * Single-argument signature — no side effects, no Date.now() calls.
 */
import type {
  WorkspaceHomeView,
  WorkspaceHomeListView,
  WorkspaceHomeSingleView,
  WorkspaceHomeConversationsView,
  WorkspaceHomeRefinementsView,
  WorkspaceHomeBriefsAssetsView,
  WorkspaceHomeActivityOverviewView,
} from "../../../../../shared/types/workspaceHome";

// ---------------------------------------------------------------------------
// Raw result shape from the composite (mode-discriminated)
// ---------------------------------------------------------------------------
interface RawCompositeResult {
  mode: string;
  [key: string]: unknown;
}

// ---------------------------------------------------------------------------
// Transform
// ---------------------------------------------------------------------------

export function transformWorkspaceHome(raw: RawCompositeResult): WorkspaceHomeView {
  switch (raw.mode) {
    case "list":
      return {
        mode: "list" as const,
        data: raw as unknown as WorkspaceHomeListView,
      };

    case "single":
      return {
        mode: "single" as const,
        data: raw as unknown as WorkspaceHomeSingleView,
      };

    case "conversations":
      return {
        mode: "conversations" as const,
        data: raw as unknown as WorkspaceHomeConversationsView,
      };

    case "refinements":
      return {
        mode: "refinements" as const,
        data: raw as unknown as WorkspaceHomeRefinementsView,
      };

    case "briefs-assets":
      return {
        mode: "briefs-assets" as const,
        data: raw as unknown as WorkspaceHomeBriefsAssetsView,
      };

    case "activity-overview":
      return {
        mode: "activity-overview" as const,
        data: raw as unknown as WorkspaceHomeActivityOverviewView,
      };

    default:
      throw new Error(`Unknown workspaceHome mode: ${raw.mode}`);
  }
}
